import { FormVersion } from '../form/form-version.enum';
import { ProjectFormExecuteType } from '../form/project-form-execute-type.enum';
import { WorkFlowTaskInfo } from '../form/work-flow-task-info.model';
import { RecordSource } from '../material/record-source.enum';
import { ArchiveFileAttach } from './archive-file-attach.model';
import { ArchiveFileExtFieldInfo } from './archive-file-ext-field-info.model';
import { ArchiveFileSource } from './archive-file-source.enum';
import { ArchiveStatus } from './archive-status.enum';
import { ArchiveVolumeType } from './archive-volume-type.enum';
import { BaseArchiveFile } from './base-archive-file.model';

export class ArchiveFile extends BaseArchiveFile {
  [key: string]: any;
  projectId?: number;
  sectionIds?: Array<number>;
  sectionNames?: string;
  superviseSectionIds?: Array<number>;
  superviseSectionNames?: string;
  sectionItemId?: number;
  sectionItemFullCode?: string;
  catalogId?: number;
  catalogName?: string;
  prevArchiveFileId?: number;
  volumeId?: number;
  volumeSortOrder?: number;
  volumeType?: ArchiveVolumeType;
  volumeTitle?: string;
  volumeCode?: string;
  volumeFileGroupSortOrder?: number;
  volumeFileSortOrder?: number;
  volumeFileId?: number;
  volumeStatus?: ArchiveStatus;
  fileSource?: ArchiveFileSource;
  recordSource?: RecordSource;
  workReportId?: number;
  workFlowId?: number;
  sectionUnitFormId?: number;
  materialInspectionId?: number;
  materialInspectionIds?: Array<number>;
  materialTypeIds?: Array<number>;
  title?: string;
  materialModelIds?: Array<number>;
  materialTypeNames?: string;
  materialModelNames?: string;
  materialBatchNos?: string;
  materialSelfReportSns?: string;
  materialSpotReportSns?: string;
  materialQaSns?: string;
  standardTestId?: number;
  standardTestType?: string;
  standardTestSelfReportSn?: string;
  standardTestSpotReportSn?: string;
  submitDate?: number | null;
  submitDateDate?: Date;
  finishDate?: number | null;
  finishDateDate?: Date;
  formSn?: string;
  formCode?: string;
  formName?: string;
  formTitle?: string;
  formCatalog?: string;
  formCatalogOrder?: number;
  formCopiesOrder?: number;
  formPdfPages?: number;
  formVersion?: FormVersion;
  formStarted?: boolean;
  formCompleted?: boolean;
  formOrder?: number;
  formExecuteType?: ProjectFormExecuteType;
  groupOrder?: number;
  signInfos?: Array<WorkFlowTaskInfo>;
  attachList?: Array<ArchiveFileAttach>;
  mAttachList?: Array<ArchiveFileAttach>;
  mNeedSpotCheck?: boolean;
  attachFileCount?: number;
  attachFileSize?: number;
  attachFilePageCount?: number;
  publishUserId?: number;
  publishUserName?: string;
  publishOrgName?: string;
  publishSectionId?: number;
  formCategory?: string;
  constructionOrgName?: string;
  supervisionOrgName?: string;
  extFields?: Array<ArchiveFileExtFieldInfo>;
  extFieldStr?: string;
  remark?: string;
  // 前端自用
  groupOrderTarget?: number;
  codeName?: string;
  volumeIdTarget?: number;
  workFlowKey?: string;
  volumeFileSortOrderTarget?: number;
}
